__turbopack_context__.v({
  "className": "FR6vBa_className",
  "variable": "FR6vBa_variable",
});
